import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../constants/allocation-view-endpoint';
@Injectable({
  providedIn: 'root',
})
export class AllocationViewSupportSMSService {
  private readonly smsSupportKey = 'allocation-view-sms-support';

  constructor(private http: WrapperHttpService) {}

  getSupportedCountryCodes(): Observable<string[]> {
    const savedCountryCodes = this.getSavedCountryCodes();
    const url = `${API_URL}${AllocationViewEndpoint.Languages}${AllocationViewEndpoint.Sms}`;
    if (savedCountryCodes && savedCountryCodes.length > 0) {
      return of(savedCountryCodes);
    } else {
      return this.http.get<string[]>(url);
    }
  }

  saveCountryCodes(items: string[]): void {
    localStorage.setItem(this.smsSupportKey, JSON.stringify(items));
  }

  getSavedCountryCodes(): string[] {
    const smsCountryCodes = localStorage.getItem(this.smsSupportKey);
    return JSON.parse(smsCountryCodes) || [];
  }
}
